var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow"},[_c('line-svg',{attrs:{"color":_vm.color,"width":_vm.width}}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.rightIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }